import React, { HTMLAttributes } from "react";
import { CommonComponentProps } from "./common";
import { cn } from "@/lib/utils";

interface FactoidProps
  extends HTMLAttributes<HTMLSpanElement>,
    CommonComponentProps {}

export function Factoid({ children, className, ...rest }: FactoidProps) {
  return (
    <span
      className={cn(
        "font-sans text-factoid-sm font-bold leading-none md:text-factoid",
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
